import { render, staticRenderFns } from "./Servicefee.vue?vue&type=template&id=3f68f311&"
import script from "./Servicefee.vue?vue&type=script&lang=js&"
export * from "./Servicefee.vue?vue&type=script&lang=js&"
import style0 from "./Servicefee.vue?vue&type=style&index=0&id=3f68f311&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports